export default {
    displayFormat: function() {return;},
    modelFormat : function(valueToFormat) {
        return valueToFormat.replace(/\s/g,'').replace(',','.');
    }
}